(function() {
    'use strict';

    angular.module('app.empleados', []);
})();
